import { fetch } from '@atlassian/eoc-fetch';

import { urls } from '../../../common/constants/urls';

import {
	type DeleteScheduleParameters,
	type TeamScheduleListResponse,
	type UpdateScheduleParameters,
	type UpdateScheduleResponse,
} from './types';

const getScheduleList = (teamId: string) => {
	return fetch<TeamScheduleListResponse>(urls.schedules.teams.teamId.url({ teamId }));
};

const updateSchedule = ({
	scheduleId,
	description,
	name,
	enabled,
	timezone,
}: UpdateScheduleParameters) => {
	return fetch<UpdateScheduleResponse>(urls.schedules.scheduleId.url({ scheduleId }), {
		method: 'PATCH',
		body: {
			description,
			name,
			enabled,
			timezone,
		},
	});
};

const deleteSchedule = ({ scheduleId }: DeleteScheduleParameters) => {
	return fetch(urls.schedules.scheduleId.url({ scheduleId }), {
		method: 'DELETE',
	});
};

export const endpoints = {
	deleteSchedule,
	getScheduleList,
	updateSchedule,
};
